import { useWorkspaceId } from "../../workspace/useWorkspaceId";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { getQueryStringFromParams } from "../../api/utils/paramUtils";
import {
    BASE_API_URL,
    HttpError,
} from "../../api/utils/useGovernmentAgencyHubAppQueryClient";
import { useHttpGovernmentAgencyHubAppHeaders } from "../../api/utils/useHttpGovernmentAgencyHubAppHeaders";
import type { DocumentDownloadDTO } from "../../dtos/DocumentDownloadDTO";

export function useDownloadTaxSubmissionPdfOutcome(
    taxSubmissionId: string,
    outcomeTypes: string[],
    taxId?: string,
) {
    const workspaceId = useWorkspaceId();
    const headers = useHttpGovernmentAgencyHubAppHeaders();
    const { t } = useTranslation();

    const query = useQuery({
        queryKey: [
            "downloadTaxSubmissionPdfOutcome",
            workspaceId,
            taxSubmissionId,
            outcomeTypes,
            taxId,
        ],
        queryFn: async (): Promise<DocumentDownloadDTO> => {
            const queryString = getQueryStringFromParams({
                outcomeTypes: outcomeTypes.join(","),
                ...(taxId ? { taxId: taxId } : {}),
            });
            const response = await fetch(
                `${BASE_API_URL}/tenants/${workspaceId}/tax-submissions/${taxSubmissionId}/pdf-outcome?${queryString}`,
                {
                    headers,
                },
            );

            if (!response.ok) {
                throw new HttpError(response);
            }

            const content = new Uint8Array(await response.arrayBuffer());
            const type = response.headers.get("content-type") ?? "";

            return {
                content,
                type,
            };
        },
        enabled: !!workspaceId,
        meta: {
            resourceName: t("errors.resourceName.taxSubmissionPdfOutcome"),
        },
    });

    return query;
}
